export default "__VITE_ASSET__FtrJR4qu__"